import React from 'react'
import Icon, { IconType } from '../../Icon'
import style from './VoteListItemRenderer.module.scss'
import { PollQuestionListItemProps, VotesMode, VoteStatus } from './../types'
import classNames from 'classnames'

const VotesListItemRenderer: React.FC<PollQuestionListItemProps> = ({ id, question, setMode, status }) => {

  return(
  <div className={classNames(style['question_container'],
        {
          [style['open']]: (status === 'open'),
          [style['closed']]: (status === 'closed')
        }
      )}
      data-bdd='talks-polls-question-container'
      onClick={() =>
        setMode({mode: (status === VoteStatus.notstarted ? VotesMode.DETAILS : VotesMode.RESULTS ), selectedVoteId: id})}>
    <div className={ classNames(style['bold'], style['qs_index']) }>
      Q:
    </div>
    <div className={ style['qs_text'] }>
      { question }
    </div>
    <div
      className={style['qs_icon']}>
      <Icon name={ IconType.iconName.votes }/>
    </div>
  </div>
  )}

export default VotesListItemRenderer
